var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: _vm.title, box: true, loading: _vm.loading } },
    [
      _c("div", { staticClass: "columns" }, [
        _c(
          "section",
          { staticClass: "column sc-files" },
          [
            _c(
              "button",
              {
                staticClass: "button is-primary sc-files__refresh",
                on: {
                  click: function($event) {
                    _vm.loadReports()
                  }
                }
              },
              [_vm._v("\n        Atualizar lista\n      ")]
            ),
            _vm._v(" "),
            _c(
              "sc-tabs",
              {
                staticClass: "sc-files__tab-group",
                attrs: { type: "is-boxed", animated: false },
                on: {
                  input: function($event) {
                    _vm.loadReports()
                  }
                },
                model: {
                  value: _vm.activeTab,
                  callback: function($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab"
                }
              },
              _vm._l(_vm.fileTypes, function(fileType, index) {
                return _c("sc-tab-item", {
                  key: index,
                  staticClass: "sc-files__tab-item",
                  attrs: { label: fileType.label }
                })
              })
            ),
            _vm._v(" "),
            _c(
              "sc-table",
              {
                staticClass: "sc-files__table",
                attrs: {
                  data: _vm.reports,
                  paginated: _vm.reports.length > _vm.perPage,
                  "per-page": _vm.perPage,
                  "default-sort": "created_at",
                  "default-sort-direction": "desc"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "sc-table-column",
                          {
                            attrs: {
                              field: "file_name",
                              label: "Arquivo",
                              sortable: ""
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.row.file_name) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          {
                            attrs: {
                              field: "created_at",
                              label: "Criado em",
                              sortable: ""
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("date")(
                                    props.row.created_at,
                                    "DD/MM/YYYY - HH:mm"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("sc-table-column", { attrs: { field: "url" } }, [
                          _c(
                            "a",
                            {
                              staticClass: "button is-primary",
                              attrs: { href: props.row.url }
                            },
                            [_vm._v("\n              Download\n            ")]
                          )
                        ])
                      ]
                    }
                  }
                ])
              },
              [
                _c(
                  "template",
                  { attrs: { slot: "empty" }, slot: "empty" },
                  [_c("sc-table-empty")],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-225da27a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-225da27a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/files/reports/PageFilesReports.vue
// module id = null
// module chunks = 